import * as parser from "@siteimprove/alfa-parser";
import { Longhand } from "./longhand.js";
const { either, end, left } = parser.Parser;
/**
 * @internal
 */
export class Shorthand {
    static of(properties, parse) {
        return new Shorthand(properties, left(either(Longhand.parseDefaults, parse), end(() => "Expected end of input")));
    }
    _properties;
    _parse;
    constructor(properties, parse) {
        this._properties = properties;
        this._parse = parse;
    }
    get properties() {
        return this._properties;
    }
    get parse() {
        return this._parse;
    }
}
//# sourceMappingURL=shorthand.js.map